enum FilterGroupEnum {
  GroupBy = 'groupBy',
  Sort = 'sort',
  ViewMode = 'viewMode',
}

export default FilterGroupEnum;
